import { Component } from '@angular/core';

@Component({
  selector: 'usb-reserving-modal',
  template: `
    <usb-popup [isLoading]="false" [showAlways]="true">
      <div class="mb-3">
        <img class="fa-spin" width="40" height="40" src="../../../../assets/icons/SPINNER.svg" alt="Spinner" />
      </div>
      <h2 class="cancel-loader_title">Reservando</h2>
      <h3 class="cancel-loader_subtitle mb-2">Productos</h3>
      <p class="cancel-loader_text">Por favor espere mientras obtenemos <br /> las respuestas</p>
    </usb-popup>
  `,
  styleUrls: ['./reserving-modal.component.scss']
})
export class ReservingModalComponent {}
